import { ErrorBoundary } from '@dixa/lib-shared-habla';
import { lazy, Suspense } from 'react';

import { useNotifications } from 'hooks/useNotifications';

import { KnowledgeErrorPlaceholder } from './components/errorPlaceholder';
import { KnowledgeLoading } from './components/loading/knowledgeLoading';

const DeliveryRoutes = lazy(() => import('lib-knowledge-internal-kb'));

export const KnowledgeDeliveryRoutes = (): JSX.Element => {
  const notify = useNotifications();
  return (
    <ErrorBoundary fallback={<KnowledgeErrorPlaceholder />}>
      <Suspense fallback={<KnowledgeLoading />}>
        <DeliveryRoutes notify={notify} />
      </Suspense>
    </ErrorBoundary>
  );
};
